export default __webpack_public_path__ + "static/media/CreativityVirus1.c67448a2.jpg";